// Command strings rendered by the cold landing walkthrough.

export const PLUGIN_MARKETPLACE_ADD_COMMAND =
  '/plugin marketplace add PilsnerChamp/buddies-onchain';

export const PLUGIN_INSTALL_COMMAND =
  '/plugin install buddy-onchain@buddies-onchain';
